// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-tools-modal__content-wrapper[data-v-431fb33d] {\n  display: block;\n  width: 100%;\n  padding: 35px;\n  padding-top: 10px;\n}\n.prof-tools-modal__add-tool-btn[data-v-431fb33d] {\n  display: inline-block;\n  width: auto;\n  margin-top: 10px;\n  padding: 0 10px;\n}\n", ""]);
// Exports
module.exports = exports;
